module.exports = __webpack_public_path__ + "img/img01.e621b520.png";